/* ============================================================
   WILD YAM — Motion system
   Calm, editorial motion. Respects prefers-reduced-motion.
   Depends on anime.js (window.anime) but degrades gracefully.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasAnime = typeof window.anime === 'function';

  /* ---------- Scroll reveal ---------- */
  function syncHeaderHeight() {
    var group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;
    var h = group.offsetHeight;
    document.documentElement.style.setProperty('--wy-header-group-height', h + 'px');
    fitMobileHero();
  }

  function fitMobileHero() {
    var heroes = document.querySelectorAll('.wy-herobg');
    if (!heroes.length) return;

    if (window.innerWidth > 749) {
      heroes.forEach(function (hero) {
        hero.style.removeProperty('height');
        hero.style.removeProperty('max-height');
        hero.style.removeProperty('min-height');
      });
      return;
    }

    var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wy-header-group-height')) || 0;
    if (!headerH) {
      var group = document.querySelector('.shopify-section-group-header-group');
      headerH = group ? group.offsetHeight : 0;
    }

    var available = Math.round(window.innerHeight - headerH);
    heroes.forEach(function (hero) {
      hero.style.height = available + 'px';
      hero.style.maxHeight = available + 'px';
      hero.style.minHeight = available + 'px';
    });
  }

  function fitWholesalePurple() {
    var hero = document.querySelector('.wy-page-hero-section');
    var stats = document.querySelector('.wy-wholesale-stats--strip');
    if (!hero || !stats) return;
    syncHeaderHeight();
    stats.style.setProperty('--wy-stats-fill', '0px');
    var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wy-header-group-height')) || 0;
    var available = window.innerHeight - headerH;
    var used = hero.offsetHeight + stats.offsetHeight;
    var extra = available - used;
    stats.style.setProperty('--wy-stats-fill', Math.max(extra, 0) + 'px');
  }

  function watchHeaderHeight() {
    syncHeaderHeight();
    fitWholesalePurple();
    window.addEventListener('resize', function () {
      syncHeaderHeight();
      fitWholesalePurple();
    }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        syncHeaderHeight();
      }, { passive: true });
    }
    var group = document.querySelector('.shopify-section-group-header-group');
    if (group && 'ResizeObserver' in window) {
      new ResizeObserver(function () {
        syncHeaderHeight();
        fitWholesalePurple();
      }).observe(group);
    }
    var hero = document.querySelector('.wy-page-hero-section');
    if (hero && 'ResizeObserver' in window) {
      new ResizeObserver(fitWholesalePurple).observe(hero);
    }
  }

  function initReveals() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.wy-reveal'));
    if (!els.length) return;

    // Auto-stagger: children of [data-wy-stagger] get incremental delay
    document.querySelectorAll('[data-wy-stagger]').forEach(function (group) {
      var step = parseFloat(group.getAttribute('data-wy-stagger')) || 0.08;
      var kids = group.querySelectorAll(':scope > .wy-reveal, .wy-reveal[data-wy-child]');
      kids.forEach(function (kid, i) {
        if (!kid.style.transitionDelay) {
          kid.style.transitionDelay = (i * step).toFixed(2) + 's';
        }
      });
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    /* Desktop: skip scroll reveals — lazy images + stagger felt like loading one-by-one. */
    if (window.innerWidth >= 900) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
        el.style.transitionDelay = '0s';
      });
      document.querySelectorAll('.wy-page-hero-section .wy-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });

    document.querySelectorAll('.wy-page-hero-section .wy-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });

    /* Safety net: never leave content hidden if IO misses (slow networks, live cache). */
    window.setTimeout(function () {
      document.querySelectorAll('.wy-reveal:not(.is-visible)').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }, 1800);
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-wy-count]'));
    if (!els.length) return;

    function paint(el, value) {
      var decimals = parseInt(el.getAttribute('data-wy-decimals') || '0', 10);
      var prefix = el.getAttribute('data-wy-prefix') || '';
      var suffix = el.getAttribute('data-wy-suffix') || '';
      el.textContent = prefix + value.toFixed(decimals) + suffix;
    }

    if (reduceMotion || !hasAnime || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { paint(el, parseFloat(el.getAttribute('data-wy-count')) || 0); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-wy-count')) || 0;
        var obj = { v: 0 };
        window.anime({
          targets: obj,
          v: target,
          duration: 1600,
          easing: 'easeOutCubic',
          update: function () { paint(el, obj.v); }
        });
      });
    }, { threshold: 0.6 });

    els.forEach(function (el) { paint(el, 0); io.observe(el); });
  }

  /* ---------- Hero purple bloom ---------- */
  function initBloom() {
    var blooms = document.querySelectorAll('[data-wy-bloom]');
    if (!blooms.length) return;
    if (reduceMotion || !hasAnime) {
      blooms.forEach(function (b) { b.style.opacity = ''; });
      return;
    }
    blooms.forEach(function (b) {
      window.anime({
        targets: b,
        scale: [0.6, 1],
        opacity: [0, 1],
        duration: 2600,
        easing: 'easeOutQuint',
        delay: 200
      });
      window.anime({
        targets: b,
        rotate: [0, 8],
        duration: 18000,
        direction: 'alternate',
        loop: true,
        easing: 'easeInOutSine'
      });
    });
  }

  /* ---------- Subtle parallax ---------- */
  function initParallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-wy-parallax]'));
    if (!els.length || reduceMotion || window.innerWidth < 750) return;

    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-wy-parallax')) || 0.12;
        var offset = (rect.top + rect.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function init() {
    watchHeaderHeight();
    initReveals();
    initCounters();
    initBloom();
    initParallax();
  }

  /* ---------- Cart offer: "add one more" reuses Dawn's + stepper ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wy-add-one]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('#CartDrawer') || document.getElementById('main-cart-items') || document;
    var plus = scope.querySelector('.quantity__button[name="plus"]');
    if (plus) plus.click();
  });

  /* ---------- FAQ accordion: opening one closes the others ----------
     Native <details name="..."> already does this in modern browsers;
     this is a fallback for browsers without exclusive-accordion support. */
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item.matches || !item.matches('details.wy-faq__item[open]')) return;
    var group = item.closest('[data-wy-accordion]');
    if (!group) return;
    group.querySelectorAll('details.wy-faq__item[open]').forEach(function (other) {
      if (other !== item) other.open = false;
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-run reveals when Shopify theme editor injects/reloads sections
  document.addEventListener('shopify:section:load', function () {
    syncHeaderHeight();
    fitWholesalePurple();
    fitMobileHero();
    initReveals();
    initCounters();
    initBloom();
  });
})();
